export const MINUS_SIGN = '−';
export const NO_DATA_TEXT = '—';
// Рубль: цены товаров магазина (премиум, кристаллы)
export const RUBLE_SIGN = '₽';
